
import { defineComponent, ref, onBeforeMount } from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import { Actions } from "@/store/enums/StoreEnums";
import { useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import CryptoJS from "crypto-js";
import { useStore } from "vuex";

export default defineComponent({
  name: "email",

  components: {
    Field,
    Form,
    ErrorMessage,
  },

  setup() {
console.log('NODE_ENV =', process.env.NODE_ENV);
    const distribuidor = "";
    const router = useRouter();
    const store = useStore();
    const linkIOS = ref("https://apps.apple.com/br/app/indicar/id1573980796");
    const linkAndroid = ref(
      "https://play.google.com/store/apps/details?id=br.com.camptecnologia.indicar&hl=pt_BR&gl=US&pli=1"
    );
    const fullscreenLoading = ref(false);


    const submitButton = ref<HTMLElement | null>(null);

    //Create form validation object
    const email = Yup.object().shape({
      email: Yup.string()
        .email("E-mail deve ser valido")
        .required("Informe e-mail")
        .label("E-mail"),
    });

    //Form submit function
    const onSubmitRecovery = (values) => {
      // values.email = CryptoJS.MD5(values.email.toLowerCase()).toString();
      // values.senha = CryptoJS.MD5(values.senha.toLowerCase()).toString();


      values.email = values.email.toLowerCase().toString();



      if (submitButton.value) {
        // Activate indicator
        submitButton.value.setAttribute("data-kt-indicator", "on");
        submitButton.value.setAttribute("disabled", "disabled");
      }

      // Send recovery request
      store
        .dispatch(Actions.RECUPERACAO, values)
        .then((response) => {
          submitButton.value?.removeAttribute("data-kt-indicator");
          submitButton.value?.removeAttribute("disabled");
          Swal.fire({
            text: response.message,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        })
        .catch(() => {
          //Deactivate indicator
          submitButton.value?.removeAttribute("data-kt-indicator");
          submitButton.value?.removeAttribute("disabled");
          Swal.fire({
            text: store.getters.getErrors,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Tente novamente!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger",
            },
          });
        });
    };

    return {
      onSubmitRecovery,
      email,
      submitButton,
      fullscreenLoading,
      distribuidor,
      linkAndroid,
      linkIOS,
    };
  },
});
